import React from 'react'
import { observer } from 'mobx-react-lite'

import { LoadOrdersForm } from './LoadOrdersForm'

import { useApi } from '../hooks/storeHook'

import { YmAccountProps } from '../types/accountProps'

export const YandexMarketLoadOrdersForm =
  observer(
    ({account}: YmAccountProps) => {
      const api = useApi()

      return (
        <LoadOrdersForm
          accountId={account.id}
          maxPeriodDays={30}
          hint="Будут загружены заказы, созданные до 00:00 конечной даты."
          loadOrders={api.userSync.loadYandexMarketOrders}
        />)
    })